import { reactive } from "vue";

// Global toast holati (barcha sahifalar bitta ro'yxatdan foydalanadi)
const state = reactive({ toasts: [] });
let counter = 0;

function show(message, type = "success", timeout = 3000) {
  const id = ++counter;
  state.toasts.push({ id, message, type });
  setTimeout(() => remove(id), timeout);
}

function remove(id) {
  const i = state.toasts.findIndex((t) => t.id === id);
  if (i !== -1) state.toasts.splice(i, 1);
}

export function useToast() {
  return {
    toasts: state.toasts,
    success: (m) => show(m, "success"),
    error: (m) => show(m, "danger"),
    info: (m) => show(m, "info"),
    remove,
  };
}
